import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { Checkbox as BaseCheckbox } from "@base-ui/react/checkbox";
import { TickIcon } from "../../primitives/Icons/Icons";
import css from "./Checkbox.module.css";

const DashIcon = () => (
  <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path
      d="M2.5 6H9.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const Checkbox = React.forwardRef(
  (
    {
      checked,
      defaultChecked,
      onCheckedChange,
      indeterminate = false,
      disabled = false,
      readOnly = false,
      required = false,
      name,
      value,
      label,
      description,
      className,
      ...rest
    },
    ref,
  ) => {
    const checkboxElement = (
      <BaseCheckbox.Root
        ref={ref}
        className={label ? css.root : clsx(css.root, className)}
        checked={checked}
        defaultChecked={defaultChecked}
        onCheckedChange={onCheckedChange}
        indeterminate={indeterminate}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        name={name}
        value={value}
        {...rest}
      >
        <BaseCheckbox.Indicator className={css.indicator}>
          {indeterminate ? <DashIcon /> : <TickIcon />}
        </BaseCheckbox.Indicator>
      </BaseCheckbox.Root>
    );

    if (!label) return checkboxElement;

    return (
      <label
        className={clsx(css.field, className)}
        data-disabled={disabled || undefined}
      >
        {checkboxElement}
        <div>
          <span className={css.label}>{label}</span>
          {description && <p className={css.description}>{description}</p>}
        </div>
      </label>
    );
  },
);

Checkbox.displayName = "Checkbox";

Checkbox.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onCheckedChange: PropTypes.func,
  indeterminate: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
};

export default Checkbox;
